import { postApi } from '../network/Network';
// import { AppContext} from "../../components/AppProvider";

export const sendFaxModule = async (faxUrl, userinfo, pxIdx, recvNum, phKey) => {
    const url = faxUrl + "center/ePresc/sendFax";

    const formData = new FormData();

    formData.append("pxIdx", pxIdx);
    formData.append("recvNum", recvNum);
    
    formData.append("phKey", phKey);
    formData.append("userToken", userinfo.userToken);
    formData.append("telNum", userinfo.userPhone);
    formData.append("userNm", userinfo.userName);

    return postApi(url, formData);
}